import React, { useState,useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Collapse,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";

import { ToastContainer, toast } from 'react-toastify';
import classnames from "classnames";
import { useParams,Link,useLocation } from "react-router-dom";

import { fetchOrders,fetchOrder,fetchPayment, confirmCODPayment } from '../../../utils/order';
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { productDetails } from "../../../common/data/ecommerce";
import OrderProduct from "./OrderProduct";
import { getLoggedinUser } from '../../../utils/api_helper_custom';
import { getBestProfilePhoto } from '../../../utils/profilePhotoUtils';
import avatar3 from "../../../assets/images/users/avatar-3.jpg"; 
const OrderDetail = (props) => {
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(true);
  const [col3, setcol3] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const [productData, setProductData] = useState([]);
  //const {orderId} = useParams(); 
  const [grandTotal, setGrandTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [dis, setDiscount] = useState(0);
  const [charge, setShippingCharge] = useState(0);
  const [tax, setTax] = useState(0);
  const [logistics, setLogisticsData] = useState(null);
  const [custom, setCustomData] = useState(null);
  const [billingAddress, setBillingAddressData] = useState(null);
  const [shippingAddress, setShippingAddressData] = useState(null);
  const [payment, setPaymentDetailsData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [orderStatusHistory, setOrderStatusHistory] = useState([]);
  const [isCODModalOpen, setIsCODModalOpen] = useState(false);
  const [codNotes, setCodNotes] = useState('');
  const [isConfirmingCOD, setIsConfirmingCOD] = useState(false);

  const location = useLocation(); // Get current location
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("orderId"); // Extract productId from query params
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successNotify = (message) => toast.success(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });

  // Check if current user can confirm COD payments
  const canConfirmCOD = () => {
    const currentUser = getLoggedinUser();
    if (!currentUser) return false;
    const allowedRoles = ['employee2', 'employee3', 'superadmin'];
    return allowedRoles.includes(currentUser.role || currentUser.user_type);
  };

  // Handle COD payment confirmation
  const handleConfirmCODPayment = async () => {
    try {
      if (!canConfirmCOD()) {
        errornotify('You do not have permission to confirm COD payments.');
        return;
      }

      if (!window.confirm(`Are you sure you want to confirm COD payment collection for Order ${orderData?.order_reference_id}?`)) {
        return;
      }

      setIsConfirmingCOD(true);
    } catch (error) {
      console.error('Error in handleConfirmCODPayment setup:', error);
      errornotify('An error occurred while setting up COD payment confirmation.');
      return;
    }
    
    try {
      const response = await confirmCODPayment(orderId, codNotes);
      
      if (response.success) {
        successNotify('COD payment confirmed successfully!');
        
        // Reload order data to get updated status
        const updatedResponse = await fetchOrder(orderId);
        if (updatedResponse.success) {
          setOrderData(updatedResponse.order_data);
          // Update other states as needed
          setSubTotal(updatedResponse.order_data.subtotal_price || 0);
          setDiscount(updatedResponse.order_data.applied_discount || 0);
          setShippingCharge(updatedResponse.order_data.delivery_fee || 0);
          setTax(updatedResponse.order_data.applied_tax || 0);
          setGrandTotal(updatedResponse.order_data.total_price || 0);
        }
        
        // Close modal and reset
        setIsCODModalOpen(false);
        setCodNotes('');
      } else {
        errornotify(response.message || 'Failed to confirm COD payment');
      }
    } catch (error) {
      errornotify(error.message || 'Network error occurred');
    } finally {
      setIsConfirmingCOD(false);
    }
  };

 
  useEffect(() => {
    const loadOrderDetailData = async () => {
      try {
         
        console.log('orderId', orderId);
         
        const response = await fetchOrder(orderId); 
         
        if(response.success){
          const orderData = response.order_data
          console.log('Order data received:', orderData);
          console.log('Product data (order_lines):', response.order_data.order_lines);
          
          // Set correct values from API response
          setSubTotal(orderData.subtotal_price || 0);
          setDiscount(orderData.applied_discount || 0);
          setShippingCharge(orderData.delivery_fee || 0);
          setTax(orderData.applied_tax || 0);
          setGrandTotal(orderData.total_price || 0);
          setProductData(response.order_data.order_lines);
          setOrderData(orderData); 
          
          // Set address and payment data from order response
          if (orderData.shipping_address) {
            setShippingAddressData({
              name: orderData.shipping_address.full_name,
              phoneNumber: orderData.shipping_address.phone_number,
              street: `${orderData.shipping_address.address_line1} ${orderData.shipping_address.address_line2 || ''}`.trim(),
              city: orderData.shipping_address.city,
              country: orderData.shipping_address.country,
              postalCode: orderData.shipping_address.postal_code
            });
          }
          
          if (orderData.billing_address) {
            setBillingAddressData({
              name: orderData.billing_address.full_name,
              phoneNumber: orderData.billing_address.phone_number,
              street: `${orderData.billing_address.address_line1} ${orderData.billing_address.address_line2 || ''}`.trim(),
              city: orderData.billing_address.city,
              country: orderData.billing_address.country,
              postalCode: orderData.billing_address.postal_code
            });
          } else {
            // If no billing address, use shipping address as billing
            if (orderData.shipping_address) {
              setBillingAddressData({
                name: orderData.shipping_address.full_name,
                phoneNumber: orderData.shipping_address.phone_number,
                street: `${orderData.shipping_address.address_line1} ${orderData.shipping_address.address_line2 || ''}`.trim(),
                city: orderData.shipping_address.city,
                country: orderData.shipping_address.country,
                postalCode: orderData.shipping_address.postal_code
              });
            }
          }
          
          if (orderData.payment_object) {
            setPaymentDetailsData({
              ...orderData.payment_object,
              stripe_session_id: orderData.stripe_session_id,
              stripe_payment_status: orderData.stripe_payment_status,
              payment_confirmed: orderData.payment_confirmed
            });
          }
          
          // Set customer data from order API response
          if (orderData.customer_details) {
            const customer = orderData.customer_details;
            console.log('Customer details from API:', customer);
            setCustomerData({
              name: customer.name || 'Customer',
              email: customer.email || 'customer@example.com',
              phoneNumber: orderData.shipping_address?.phone_number || 'N/A',
              img: customer.profile_photo_url_object?.profile_url ? 
                   `http://localhost:5500/api/file/avatar/${customer.profile_photo_url_object.profile_url}` :
                   customer.profile_photo_url_object?.fullsize_url ?
                   `http://localhost:5500/api/file/avatar/${customer.profile_photo_url_object.fullsize_url}` :
                   avatar3,
              description: customer.role || 'Customer'
            });
          } else {
            // Fallback if no customer details in API response
            const currentUser = getLoggedinUser();
            if (currentUser) {
              setCustomerData({
                name: currentUser.name || 
                      (currentUser.first_name && currentUser.last_name ? 
                        `${currentUser.first_name} ${currentUser.last_name}` : 
                        currentUser.first_name || currentUser.last_name || 'Customer'),
                email: currentUser.email || 'customer@example.com',
                phoneNumber: currentUser.phone_number || 
                            currentUser.phone || 
                            orderData.shipping_address?.phone_number || 'N/A',
                img: getBestProfilePhoto(currentUser) || avatar3,
                description: currentUser.role || 
                            currentUser.user_type || 
                            'Customer'
              });
            } else {
              setCustomerData({
                name: 'Customer',
                email: 'customer@example.com',
                phoneNumber: orderData.shipping_address?.phone_number || 'N/A',
                img: avatar3,
                description: 'Customer'
              });
            }
          }
          
          // Determine payment mode based on payment method and status
          const determinePaymentMode = (orderData) => {
            console.log('🔍 Determining payment mode for order:', {
              orderId: orderData.id,
              stripe_payment_status: orderData.stripe_payment_status,
              payment_confirmed: orderData.payment_confirmed,
              paid_delivery: orderData.paid_delivery,
              payment_method: orderData.payment_object?.payment_method,
              payment_status: orderData.payment_object?.status
            });

            // Check if it's COD payment
            if (orderData.stripe_payment_status === 'cod' || 
                orderData.stripe_payment_status === 'cod_pending' || 
                orderData.stripe_payment_status === 'cod_collected' ||
                orderData.payment_object?.payment_method === 'Cash on Delivery') {
              console.log('✅ Payment mode determined: COD');
              return 'COD';
            }
            
            // Check if it's a successful Stripe payment
            if (orderData.stripe_payment_status === 'succeeded' || 
                orderData.stripe_payment_status === 'paid' ||
                orderData.payment_confirmed === true ||
                (orderData.payment_object?.payment_method && 
                 orderData.payment_object.payment_method !== 'Unknown' &&
                 orderData.payment_object.payment_method !== 'Cash on Delivery')) {
              console.log('✅ Payment mode determined: Prepaid');
              return 'Prepaid';
            }
            
            // Check if payment is pending
            if (orderData.stripe_payment_status === 'pending' || 
                orderData.stripe_payment_status === 'processing') {
              console.log('✅ Payment mode determined: Pending');
              return 'Pending';
            }
            
            // Fallback to paid_delivery field if available
            if (orderData.paid_delivery !== undefined) {
              const mode = orderData.paid_delivery ? 'Prepaid' : 'COD';
              console.log('⚠️ Using paid_delivery fallback:', mode);
              return mode;
            }
            
            // Default fallback
            console.log('❌ Payment mode determined: Unknown (fallback)');
            return 'Unknown';
          };

          // Set logistics data based on order status and tracking info
          setLogisticsData({
            logistics: orderData.carrier || 'Standard Shipping',
            id: orderData.tracking_number || orderData.order_reference_id,
            payMode: determinePaymentMode(orderData),
            trackingNumber: orderData.tracking_number,
            estimatedDelivery: orderData.estimated_delivery_date,
            actualDelivery: orderData.actual_delivery_date,
            deliveryNotes: orderData.delivery_notes
          });
          
          // Create order status history based on current status
          createOrderStatusHistory(orderData);
          
          // Set logistics data if available (may come from different endpoint)
          if (response.data) {
            setCustomData(response.data.custom);
          } 
        }else{
          errornotify(response.message)  
        }
      } catch (error) {
        errornotify(error) 
      } finally {
        // setLoading(false);
      }
    };

    loadOrderDetailData();
  }, []);
  

  function togglecol1() {
    setcol1(!col1);
  }

  function togglecol2() {
    setcol2(!col2);
  }

  function togglecol3() {
    setcol3(!col3);
  }
  // Note: Order summary is now populated directly from API response in useEffect
  // This function is kept for potential future cart-related functionality
  const updateOrderSummary = (cartData) => {
    // This function is currently not used as order data comes from API
    // Values are set directly from fetchOrder response in useEffect
    console.log('updateOrderSummary called but not used - order data comes from API');
  };

  // Create order status history based on current order status
  const createOrderStatusHistory = (orderData) => {
    const statusHistory = [];
    const orderDate = new Date(orderData.created_at);
    
    // Always add order placed
    statusHistory.push({
      id: 1,
      status: 'Order Placed',
      date: orderDate,
      description: 'Your order has been placed successfully',
      completed: true,
      icon: 'ri-shopping-bag-line',
      color: 'bg-primary'
    });

    // Add status based on current order status
    const statusMap = {
      'pending': { status: 'Pending', description: 'Order is being processed', completed: false },
      'pending_payment': { status: 'Pending Payment', description: 'Waiting for payment confirmation', completed: false },
      'paid': { status: 'Paid', description: 'Payment received and confirmed', completed: true },
      'confirmed': { status: 'Confirmed', description: 'Order confirmed and ready for processing', completed: true },
      'processing': { status: 'Processing', description: 'Order is being prepared', completed: true },
      'packed': { status: 'Packed', description: 'Order has been packed and ready for shipping', completed: true },
      'shipped': { status: 'Shipped', description: 'Order has been shipped', completed: true },
      'out_for_delivery': { status: 'Out for Delivery', description: 'Order is out for delivery', completed: true },
      'delivered': { status: 'Delivered', description: 'Order has been delivered', completed: true },
      'completed': { status: 'Completed', description: 'Order completed successfully', completed: true },
      'cancelled': { status: 'Cancelled', description: 'Order has been cancelled', completed: true },
      'refunded': { status: 'Refunded', description: 'Order has been refunded', completed: true }
    };

    const currentStatus = statusMap[orderData.status];
    if (currentStatus) {
      statusHistory.push({
        id: 2,
        status: currentStatus.status,
        date: new Date(orderData.updated_at),
        description: currentStatus.description,
        completed: currentStatus.completed,
        icon: currentStatus.completed ? 'ri-check-line' : 'ri-time-line',
        color: currentStatus.completed ? 'bg-success' : 'bg-warning'
      });
    }

    // Add tracking info if available
    if (orderData.tracking_number) {
      statusHistory.push({
        id: 3,
        status: 'Tracking Available',
        date: new Date(orderData.updated_at),
        description: `Tracking Number: ${orderData.tracking_number}`,
        completed: true,
        icon: 'ri-truck-line',
        color: 'bg-info'
      });
    }

    setOrderStatusHistory(statusHistory);
  };

  document.title = "Order Details | SeedNations";
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Order Details" pageTitle="Order List" /> 
        <Row>
        <ToastContainer />
          <Col xl={9}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">
                    {orderData?.order_reference_id ? `ORDER ${orderData.order_reference_id}` : `Order ${orderId}`}
                  </h5>
                  <div className="flex-shrink-0">
                    <Link
                      to={`/order-invoice?orderId=${orderId}`}
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="ri-download-2-fill align-middle me-1"></i>{" "}
                      Invoice
                    </Link>
                    {orderData?.stripe_payment_status === 'cod' && 
                     orderData?.status === 'cod_pending' && 
                     canConfirmCOD() && (
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => setIsCODModalOpen(true)}
                      >
                        <i className="ri-check-line align-middle me-1"></i>
                        Confirm COD Payment
                      </Button>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div className="table-responsive table-card">
                  <table className="table table-nowrap align-middle table-borderless mb-0">
                    <thead className="table-light text-muted">
                      <tr>
                        <th scope="col">Product Details</th>
                        <th scope="col">Item Price</th>
                        <th scope="col">Quantity</th> 
                        <th scope="col" className="text-end">
                          Total Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData?productData.map((product, key) => (
                        <OrderProduct product={product} key={key} />
                      )):""}
                      <tr className="border-top border-top-dashed">
                        <td colSpan="3"></td>
                        <td colSpan="2" className="fw-medium p-0">
                          <table className="table table-borderless mb-0">
                            <tbody>
                              <tr>
                                <td>Sub Total :</td>
                                <td className="text-end">${subTotal}</td>
                              </tr>
                              {dis > 0 && (
                                <tr>
                                  <td>Discount :</td>
                                  <td className="text-end">-${dis}</td>
                                </tr>
                              )}
                              {charge > 0 && (
                                <tr>
                                  <td>Delivery Fee :</td>
                                  <td className="text-end">${charge}</td>
                                </tr>
                              )}
                              {tax > 0 && (
                                <tr>
                                  <td>Estimated Tax :</td>
                                  <td className="text-end">${tax}</td>
                                </tr>
                              )}
                              <tr className="border-top border-top-dashed">
                                <th scope="row">Total (USD) :</th>
                                <th className="text-end">${grandTotal}</th>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <div className="d-sm-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">Order Status</h5>
                  <div className="flex-shrink-0 mt-2 mt-sm-0">
                    <Link
                      to="#"
                      className="btn btn-soft-primary btn-sm mt-2 mt-sm-0"
                    >
                      <i className="ri-map-pin-line align-middle me-1"></i>{" "}
                      Change Address
                    </Link>{" "}
                    <Link
                      to="#"
                      className="btn btn-soft-secondary btn-sm mt-2 mt-sm-0"
                    >
                      <i className="mdi mdi-archive-remove-outline align-middle me-1"></i>{" "}
                      Cancel Order
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div className="profile-timeline">
                  <div
                    className="accordion accordion-flush"
                    id="accordionFlushExample"
                  >
                    {orderStatusHistory.map((statusItem, index) => (
                      <div key={statusItem.id} className="accordion-item border-0" onClick={() => {
                        if (index === 0) togglecol1();
                        else if (index === 1) togglecol2();
                        else if (index === 2) togglecol3();
                      }}>
                        <div className="accordion-header" id={`heading${index + 1}`}>
                          <Link to="#" className={classnames(
                            "accordion-button",
                            "p-2",
                            "shadow-none",
                            { collapsed: index === 0 ? !col1 : index === 1 ? !col2 : !col3 }
                          )}>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 avatar-xs">
                                <div className={`avatar-title ${statusItem.color} rounded-circle`}>
                                  <i className={statusItem.icon}></i>
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h6 className="fs-15 mb-0 fw-semibold">
                                  {statusItem.status} -{" "}
                                  <span className="fw-normal">
                                    {statusItem.date.toLocaleDateString('en-US', { 
                                      weekday: 'short', 
                                      year: 'numeric', 
                                      month: 'short', 
                                      day: 'numeric' 
                                    })}
                                  </span>
                                </h6>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <Collapse
                          id={`collapse${index + 1}`}
                          className="accordion-collapse"
                          isOpen={index === 0 ? col1 : index === 1 ? col2 : col3}
                        >
                          <div className="accordion-body ms-2 ps-5 pt-0">
                            <h6 className="mb-1">{statusItem.description}</h6>
                            <p className="text-muted">
                              {statusItem.date.toLocaleString('en-US', { 
                                weekday: 'short', 
                                year: 'numeric', 
                                month: 'short', 
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </p>
                            {statusItem.completed && (
                              <div className="mt-2">
                                <span className="badge bg-success-subtle text-success">
                                  <i className="ri-check-line me-1"></i>
                                  Completed
                                </span>
                              </div>
                            )}
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3}>
            <Card>
              <CardHeader>
                <div className="d-flex">
                  <h5 className="card-title flex-grow-1 mb-0">
                    <i className="mdi mdi-truck-fast-outline align-middle me-1 text-muted"></i>
                    Logistics Details
                  </h5>
                  <div className="flex-shrink-0">
                    <Link to="#" className="badge bg-primary-subtle text-primary fs-11">
                      Track Order
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div className="text-center">
                  <lord-icon
                    src="https://cdn.lordicon.com/uetqnvvg.json"
                    trigger="loop"
                    colors="primary:#25a0e2,secondary:#00bd9d"
                    style={{ width: "80px", height: "80px" }}
                  ></lord-icon>
                  <h5 className="fs-16 mt-2">{logistics?.logistics || 'Standard Shipping'}</h5>
                  <p className="text-muted mb-0">Order ID: {logistics?.id || orderId}</p>
                  <p className="text-muted mb-0">Payment Mode: {logistics?.payMode || 'Prepaid'}</p>
                  {logistics?.trackingNumber && (
                    <div className="mt-3">
                      <p className="text-primary mb-1"><strong>Tracking Number:</strong></p>
                      <p className="font-monospace fs-14">{logistics.trackingNumber}</p>
                    </div>
                  )}
                  {logistics?.estimatedDelivery && (
                    <div className="mt-2">
                      <p className="text-muted mb-0">
                        <i className="ri-calendar-line me-1"></i>
                        Est. Delivery: {new Date(logistics.estimatedDelivery).toLocaleDateString()}
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <div className="d-flex">
                  <h5 className="card-title flex-grow-1 mb-0">
                    Customer Details
                  </h5>
                  <div className="flex-shrink-0">
                    <Link to="#" className="link-secondary">
                      View Profile
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <ul className="list-unstyled mb-0 vstack gap-3">
                  <li>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img
                          src={customerData?.img || avatar3}
                          alt="Customer Avatar"
                          className="avatar-sm rounded"
                          onError={(e) => {
                            e.target.src = avatar3;
                          }}
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h6 className="fs-14 mb-1">{customerData?.name || 'Customer'}</h6>
                        <p className="text-muted mb-0">{customerData?.description || 'Customer'}</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <i className="ri-mail-line me-2 align-middle text-muted fs-16"></i>
                    {customerData?.email || 'N/A'}
                  </li>
                  <li>
                    <i className="ri-phone-line me-2 align-middle text-muted fs-16"></i>
                    {customerData?.phoneNumber || 'N/A'}
                  </li>
                </ul>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">
                  <i className="ri-map-pin-line align-middle me-1 text-muted"></i>{" "}
                  Billing Address
                </h5>
              </CardHeader>
              <CardBody>
                <ul className="list-unstyled vstack gap-2 fs-13 mb-0">
                  <li className="fw-medium fs-14">{billingAddress?.name || 'N/A'}</li>
                  <li><i className="ri-phone-line me-1"></i>{billingAddress?.phoneNumber || 'N/A'}</li>
                  <li><i className="ri-map-pin-line me-1"></i>{billingAddress?.street || 'N/A'}</li>
                  <li>{billingAddress?.city || 'N/A'}, {billingAddress?.postalCode || 'N/A'}</li>
                  <li>{billingAddress?.country || 'N/A'}</li>
                </ul>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">
                  <i className="ri-map-pin-line align-middle me-1 text-muted"></i>{" "}
                  Shipping Address
                </h5>
              </CardHeader>
              <CardBody>
                <ul className="list-unstyled vstack gap-2 fs-13 mb-0">
                  <li className="fw-medium fs-14">{shippingAddress?.name || 'N/A'}</li>
                  <li><i className="ri-phone-line me-1"></i>{shippingAddress?.phoneNumber || 'N/A'}</li>
                  <li><i className="ri-map-pin-line me-1"></i>{shippingAddress?.street || 'N/A'}</li>
                  <li>{shippingAddress?.city || 'N/A'}, {shippingAddress?.postalCode || 'N/A'}</li>
                  <li>{shippingAddress?.country || 'N/A'}</li>
                </ul>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">
                  <i className="ri-secure-payment-line align-bottom me-1 text-muted"></i>{" "}
                  Payment Details
                </h5>
              </CardHeader>
              <CardBody>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Payment Status:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <span className={`badge ${payment?.stripe_payment_status === 'succeeded' ? 'bg-success' : payment?.stripe_payment_status === 'pending' ? 'bg-warning' : 'bg-danger'}`}>
                      {payment?.stripe_payment_status || payment?.status || 'Unknown'}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Total Amount:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">${payment?.total_amount || grandTotal}</h6>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Payment Confirmed:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <span className={`badge ${payment?.payment_confirmed ? 'bg-success' : 'bg-warning'}`}>
                      {payment?.payment_confirmed ? 'Yes' : 'No'}
                    </span>
                  </div>
                </div>
                {payment?.stripe_session_id && (
                  <div className="d-flex align-items-center mb-2">
                    <div className="flex-shrink-0">
                      <p className="text-muted mb-0">Session ID:</p>
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <small className="text-muted font-monospace">{payment.stripe_session_id}</small>
                    </div>
                  </div>
                )}
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Payment Method:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">
                      {orderData?.stripe_payment_status === 'cod' || 
                       orderData?.stripe_payment_status === 'cod_pending' || 
                       orderData?.stripe_payment_status === 'cod_collected' 
                        ? 'Cash on Delivery' 
                        : orderData?.payment_object?.payment_method === 'Unknown' 
                        ? 'Stripe Payment'
                        : orderData?.payment_object?.payment_method || 'Stripe Payment'
                      }
                    </h6>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* COD Payment Confirmation Modal */}
        <Modal isOpen={isCODModalOpen} toggle={() => {
          try {
            setIsCODModalOpen(false);
          } catch (error) {
            console.error('Error closing COD modal:', error);
          }
        }} size="md">
          <ModalHeader toggle={() => {
            try {
              setIsCODModalOpen(false);
            } catch (error) {
              console.error('Error closing COD modal from header:', error);
            }
          }}>
            Confirm COD Payment Collection
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <h6>Order Details:</h6>
              <p><strong>Order Reference:</strong> {orderData?.order_reference_id}</p>
              <p><strong>Order ID:</strong> #{orderId}</p>
              <p><strong>Amount:</strong> ${orderData?.total_price}</p>
            </div>

            <Form>
              <FormGroup>
                <Label for="cod-notes">
                  Delivery Notes <span className="text-muted">(Optional)</span>
                </Label>
                <Input
                  type="textarea"
                  id="cod-notes"
                  name="notes"
                  value={codNotes}
                  onChange={(e) => setCodNotes(e.target.value)}
                  placeholder="e.g., Cash collected by John Doe at 2:30 PM"
                  rows={3}
                />
                <small className="form-text text-muted">
                  Add any notes about the payment collection process.
                </small>
              </FormGroup>
            </Form>

            <div className="alert alert-warning mt-3">
              <strong>Warning:</strong> This action will confirm that the COD payment has been collected 
              and will update the order status. This action cannot be undone.
            </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              color="secondary" 
              onClick={() => {
                try {
                  setIsCODModalOpen(false);
                  setCodNotes('');
                } catch (error) {
                  console.error('Error closing COD modal from cancel button:', error);
                }
              }}
              disabled={isConfirmingCOD}
            >
              Cancel
            </Button>
            <Button 
              color="success" 
              onClick={handleConfirmCODPayment}
              disabled={isConfirmingCOD}
            >
              {isConfirmingCOD ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Confirming...
                </>
              ) : (
                'Confirm Payment Collection'
              )}
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default OrderDetail;